import { AudioTranscriptionHook } from './ui/AudioTranscriptionHook';

export {
  AudioTranscriptionProvider,
  useAudioTranscriptionFeature,
  AudioTranscriptionDebugNotice,
} from './ui/AudioTranscriptionProvider';
export { AudioTranscriptionTriggerButton } from './ui/AudioTranscriptionTriggerButton';
export { AudioTranscriptionEventBus } from './core/AudioTranscriptionEventBus';
export { AudioTranscriptionFeatureModule } from './AudioTranscriptionFeatureModule';
export { AudioTranscriptionHook } from './ui/AudioTranscriptionHook';

export const useAudioTranscription = AudioTranscriptionHook.useAudioTranscription;
